<template>
  <div class="video-overlay is-overlay">
    <div v-if="state.location.percent < 0.98">
      <h2>{{ video.pagetitle }}</h2>
      <p class="time-to-end">זמן לסיום: {{ timeToEnd }}</p>
      <button class="play-btn" @click="resume">
        <span>המשך סרטון</span>
        <i class="mdi mdi-play"></i>
      </button>
    </div>

    <div v-if="state.location.percent > 0.98">
      <div class="next-videos" v-if="$route.params.sid">
        <h3 v-if="!isLast">כל הכבוד! סיימת עוד שיעור בתוכנית האימון שלך.</h3>
        <button class="yoga-btn" v-if="!isLast" @click="$emit('load-next')">
          המשך לשיעור הבא
        </button>

        <div v-else style="width: 100%;">
          <h3>כל הכבוד סיימת תוכנית אימון מלאה!</h3>
          <p>אנו גאים בך על ההתמדה.</p>
          <div v-if="nextSeries > 0">
            <p>אנחנו מזמינים אותך להמשיך ישר לתוכנית האימון</p>
            <gv-item :item="nextSeriesObj"></gv-item>
          </div>
          <router-link class="yoga-btn-beige" :to="{ name: 'series' }"
            >לרשימת כל תכניות האימון</router-link
          >
          <h4>שתף</h4>
          <a :href="video.shareUrl" target="_blank">
            <i class="mdi mdi-facebook blue" title="שיתוף בפייסבוק"></i>
          </a>
        </div>
      </div>
      <div v-else class="next-videos">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="150"
          height="71"
          viewBox="0 0 126.8 66.5"
        >
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st1"
            d="M76.7 34.3c-3.3-0.7-5.9-2.5-8.1-4.8 -2.3-2.3-3.7-5.1-4.9-8.4 -0.2 0.6-0.4 0.9-0.5 1.3 -1.6 4.1-4.1 7.5-7.8 9.9 -1.2 0.8-2.6 1.5-4.1 1.8 -0.2 0.1-0.4 0.1-0.7 0.1 -0.3-0.6 0.1-0.7 0.4-1 1.1-0.7 2.1-1.3 3.2-2 4.7-3.4 7.2-8.2 8.3-13.7 0.2-0.9 0-1.9 0-2.8 0-0.9 0.1-1.8 0.1-2.7 0-0.6 0-1.2 0-2 0.6-0.5 1.3-0.5 2 0 0 2.3 0 4.5 0 6.8 0 0.6 0.2 1.2 0.3 1.8 1.6 6.3 5 11.1 10.7 14.3C76.2 33.2 76.9 33.3 76.7 34.3z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M63.7 20.6c-5 0-9-4-9-9 0-5 4-9 9-9 5 0 9 4 9 9C72.7 16.6 68.6 20.6 63.7 20.6zM63.7 4C59.4 4 56 7.4 56 11.6c0 4.2 3.4 7.7 7.7 7.7 4.2 0 7.7-3.4 7.7-7.7C71.3 7.4 67.9 4 63.7 4z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M5.7 64.7c0.5-0.2 1-0.3 1.5-0.3v-5l-4-6.7c-0.4-0.1-0.9-0.2-1.4-0.3v-0.2H6v0.2c-0.5 0.2-1 0.3-1.5 0.3l3.6 6.1 3.9-6.2c-0.4-0.1-0.8-0.2-1.2-0.3v-0.2h3v0.2c-0.3 0.1-0.6 0.2-1 0.3l-4.3 6.8v5c0.6 0.1 1.1 0.2 1.5 0.3v0.2H5.7V64.7z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M19 63.3c-1-1.2-1.5-2.8-1.5-4.8 0-2.1 0.5-3.7 1.5-4.8 1-1.2 2.4-1.7 4.2-1.7 1.8 0 3.2 0.6 4.2 1.7 1 1.2 1.5 2.8 1.5 4.8 0 2-0.5 3.7-1.5 4.8 -1 1.2-2.4 1.7-4.2 1.7C21.4 65 20 64.4 19 63.3zM26.4 62.8c0.7-1.1 1.1-2.5 1.1-4.3 0-1.8-0.4-3.2-1.1-4.3 -0.7-1.1-1.8-1.6-3.3-1.6 -1.4 0-2.5 0.5-3.3 1.6 -0.7 1.1-1.1 2.5-1.1 4.3 0 1.8 0.4 3.3 1.1 4.3 0.7 1.1 1.8 1.6 3.3 1.6C24.6 64.4 25.7 63.9 26.4 62.8z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M35.3 63.3c-1-1.2-1.5-2.8-1.5-4.8 0-1.3 0.2-2.5 0.7-3.5 0.5-1 1.1-1.7 2-2.3 0.9-0.5 1.9-0.8 3.1-0.8 0.8 0 1.6 0.1 2.4 0.3 0.8 0.2 1.4 0.5 1.8 0.9l-0.1 2.1h-0.3c-0.1-0.3-0.2-1-0.3-1.9 -0.2-0.2-0.7-0.4-1.3-0.5 -0.6-0.2-1.2-0.2-1.7-0.2 -1.6 0-2.8 0.5-3.6 1.6 -0.8 1.1-1.2 2.5-1.2 4.3 0 1.8 0.4 3.3 1.1 4.3 0.7 1.1 1.9 1.6 3.5 1.6 0.4 0 0.8-0.1 1.3-0.2 0.5-0.1 0.9-0.3 1.3-0.4v-4.7c-0.6-0.1-1.1-0.2-1.5-0.3v-0.2h4v0.2c-0.4 0.2-0.8 0.3-1.3 0.4v4.7c-0.4 0.4-1 0.6-1.8 0.8 -0.7 0.2-1.5 0.3-2.3 0.3C37.7 65 36.3 64.4 35.3 63.3z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M61.4 64.7v0.2h-4.2v-0.2c0.4-0.2 0.9-0.3 1.5-0.3l-1-2.8h-5.7l-1 2.8c0.6 0.1 1.1 0.2 1.5 0.3v0.2h-3.7v-0.2c0.5-0.2 0.9-0.3 1.4-0.3L54.7 52h0.9L60 64.3C60.5 64.4 61 64.5 61.4 64.7zM57.5 60.9l-2.6-7.4 -2.6 7.4H57.5z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M74.4 64.7c0.5-0.2 1-0.3 1.5-0.3V52.6c-0.6-0.1-1.1-0.2-1.5-0.3v-0.2h3l7.4 11V52.6c-0.6-0.1-1.1-0.2-1.5-0.3v-0.2h3.7v0.2c-0.3 0.1-0.8 0.2-1.5 0.3v12.2h-0.8l-8.1-12v11.5c0.5 0.1 1 0.2 1.5 0.3v0.2h-3.7V64.7z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M93.5 63.3c-1-1.2-1.5-2.8-1.5-4.8 0-2.1 0.5-3.7 1.5-4.8 1-1.2 2.4-1.7 4.2-1.7 1.8 0 3.2 0.6 4.2 1.7 1 1.2 1.5 2.8 1.5 4.8 0 2-0.5 3.7-1.5 4.8 -1 1.2-2.4 1.7-4.2 1.7C95.9 65 94.5 64.4 93.5 63.3zM100.9 62.8c0.7-1.1 1.1-2.5 1.1-4.3 0-1.8-0.4-3.2-1.1-4.3 -0.7-1.1-1.8-1.6-3.3-1.6 -1.4 0-2.5 0.5-3.3 1.6 -0.7 1.1-1.1 2.5-1.1 4.3 0 1.8 0.4 3.3 1.1 4.3s1.8 1.6 3.3 1.6C99.1 64.4 100.2 63.9 100.9 62.8z"
          />
          <!-- eslint-disable-next-line max-len -->
          <path
            class="st0"
            d="M108.7 52.6c-0.5-0.1-1-0.2-1.4-0.4v-0.2h4.2v0.2c-0.4 0.2-0.9 0.3-1.5 0.3l2.6 10.6 3.2-10.5h0.7l3.6 10.9 3-11.1c-0.4-0.1-0.7-0.2-1.1-0.3v-0.2h2.9v0.2c-0.4 0.2-0.7 0.3-1.1 0.3L120.5 65h-1.1L116 54.6 112.8 65h-0.9L108.7 52.6z"
          />
        </svg>
        <hr />
        <div v-if="!sending">
          <h3>כל הכבוד סיימת את השיעור!</h3>
          <h3>נהנת?</h3>
          <button class="yoga-btn" @click="sendFeedback">
            שלח/י <i class="mdi mdi-heart"></i> למורה
          </button>
        </div>
        <div v-else>
          <div v-if="$store.state.teacherFeedback.showSpinner">
            <load-spinner></load-spinner>
          </div>
          <div v-else>
            <div v-if="$store.state.teacherFeedback.error">
              <h3 class="has-text-danger">אירעה שגיאה בנסיון השליחה</h3>
            </div>
            <div v-else>
              <h3 class="feedback-success">
                ה<i class="mdi mdi-heart"></i> נשלח
              </h3>
            </div>
          </div>
        </div>
        <h3 class="is-hidden-touch">שיעורי {{ current.label }} נוספים</h3>
        <videos
          :videos="moreVideos"
          class="is-hidden-touch next-videos"
        ></videos>
      </div>
    </div>
  </div>
</template>

<script>
import Videos from "@/components/Videos.vue";
import GvItem from "@/components/series/GvItem.vue";
import LoadSpinner from "@/components/LoadSpinner.vue";

const shuffleArray = array => {
  // eslint-disable-next-line
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // eslint-disable-line no-param-reassign
  }
};

export default {
  name: `VideoOverlay`,
  props: {
    video: Object,
    state: Object,
    player: Object,
    isLast: {
      type: Boolean,
      default: false,
    },
    nextSeries: Number,
  },
  methods: {
    resume() {
      this.player.play();
    },
    sendFeedback() {
      this.$store.dispatch(`sendTeacherFeedback`, {
        videoId: this.video.id,
        teacherId: this.video.videoTeacher,
      });
    },
  },

  components: {
    Videos,
    GvItem,
    LoadSpinner,
  },

  computed: {
    timeToEnd() {
      const secs = this.state.location.duration - this.state.location.seconds;
      if (secs > 60) {
        return `${Math.floor(secs / 60)} דקות`;
      }
      return `${Math.floor(secs)} שניות`;
    },

    current() {
      if (this.$store.state.initialData.currents) {
        const arr = this.$store.state.initialData.currents.filter(c => {
          if (
            typeof c.resource !== `undefined` &&
            c.resource.id === this.video.current
          ) {
            return true;
          }
          return false;
        });
        return arr[0];
      }
      return {};
    },

    moreVideos() {
      if (this.$store.state.videos) {
        const arr = this.$store.state.videos.filter(v => {
          if (
            typeof v.current !== `undefined` &&
            v.current === this.current.resource.id
          ) {
            return true;
          }
          return false;
        });
        shuffleArray(arr);
        return arr.slice(0, 3);
      }
      return [];
    },

    nextSeriesObj() {
      if (this.nextSeries > 0) {
        const series = this.$store.state.series;
        // eslint-disable-next-line
        const arr = series.filter(
          // eslint-disable-next-line
          s => parseInt(s.id, 10) === this.nextSeries
          // eslint-disable-next-line
        );
        return arr[0];
      }
      return {};
    },

    sending() {
      return this.$store.state.teacherFeedback.sending;
    },
  },
};
</script>

// <style lang="scss">
// $overlayBg: #dedede;
// $white: #ffffff;
// $crimsonish: #976177;
// $text: #191919;
// $purple: #656b85;

// .video-overlay {
//   background-color: $overlayBg;
//   padding: 15px;
//   text-align: center;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   z-index: 10;
//   h2 {
//     color: $purple;
//     font-size: 16px;
//     font-weight: 300;
//     margin-bottom: 5px;
//   }

//   .time-to-end {
//     color: $purple;
//     font-size: 16px;
//     margin: 10px 0;
//   }

//   .yoga-btn {
//     font-size: 1.5rem;
//   }

//   .next-videos {
//     color: $purple;
//     .mdi-facebook {
//       font-size: 48px;
//       background-color: $white;
//     }

//     h3 {
//       font-size: 21px;
//       font-weight: 900;
//     }

//     .is-half {
//       width: 100%;
//     }

//     .group-video {
//       p {
//         display: none;
//       }
//       .s-current {
//         display: none;
//       }
//       hr {
//         display: none;
//       }
//     }

//     hr {
//       background-color: $purple;
//       margin: 1rem auto;
//       max-width: 200px;
//     }

//     .yoga-btn {
//       margin-top: 1rem;
//     }

//     .next-videos {
//       margin-top: 2rem;
//       max-width: 1000px;
//     }

//     .feedback-success {
//       color: #fd7170;
//       font-size: 1.5rem;
//     }
//   }
//   .video-item {
//     max-width: 250px;
//     h4 {
//       color: $text;
//       font-size: 0.9rem;
//     }
//     p,
//     h5 {
//       display: none;
//     }
//   }
// }

// .play-btn {
//   background-color: $crimsonish;
//   border: 0;
//   color: $white;
//   font-size: 12px;
//   font-weight: 300;
//   padding: 5px;
//   height: 100px;
//   width: 100px;
//   cursor: pointer;
//   border-radius: 50%;
//   transition: all 300ms ease;

//   span {
//     transform: translateY(10px);
//     display: inline-block;
//   }

//   .mdi {
//     display: block;
//     margin-top: 5px;
//     font-size: 4em;
//     transform: rotateZ(180deg);
//   }

//   &:hover {
//     background-color: $white;
//     color: $crimsonish;
//   }
// }

// .st1,
// .st0 {
//   fill: $purple;
// }

// @media screen and (min-width: 768px) {
//   .video-overlay {
//     h2 {
//       font-size: 24px;
//       margin-bottom: 20px;
//     }
//     .time-to-end {
//       font-size: 24px;
//       margin: 30px 0;
//     }
//   }

//   .play-btn {
//     font-size: 21px;
//     height: 190px;
//     width: 190px;

//     span {
//       transform: translateY(30px);
//     }

//     .mdi {
//       font-size: 5em;
//     }
//   }
// }
// </style>
